import { Swatch } from '@/components/ui'
import { cn, semanticColors } from '@/utils'

interface OverviewBarRowProps {
  label: string
  fraction: number
  value: string
  valueMuted?: string
  color?: string
  className?: string
}

// Shared row for the account-mix and top-categories cards.
// fraction is 0..1 of the card's reference max. Color carries meaning (account type / category).
export const OverviewBarRow = ({
  label,
  fraction,
  value,
  valueMuted,
  color = semanticColors.primary,
  className,
}: OverviewBarRowProps) => (
  <div
    className={cn(
      '-mx-2 rounded-md px-2 py-1.5 transition-colors hover:bg-blue-1',
      className,
    )}
  >
    <div className="flex items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-2">
        <Swatch size="md" shape="square" color={color} />
        <span className="truncate text-sm text-blue-7" title={label}>
          {label}
        </span>
      </div>
      <div className="shrink-0 tabular-nums">
        <span className="text-sm font-semibold text-blue-7">{value}</span>
        {valueMuted ? (
          <span className="ml-1.5 text-xs text-blue-4">{valueMuted}</span>
        ) : null}
      </div>
    </div>
    <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-neutral-100">
      <div
        className="h-full rounded-full transition-[width] duration-500 ease-out"
        style={{
          width: `${Math.max(2, Math.min(100, fraction * 100))}%`,
          backgroundColor: color,
        }}
      />
    </div>
  </div>
)
